module.exports = __webpack_public_path__ + "img/logo_RONGLIAN_bioCloud.feaae08d.png";